import React from 'react';
import { Visibility } from '../components';
import { ListingFormState } from '../types';
import { StyledForm } from '../StyledComponents';

type VisibilityFormProps = {
  listing: ListingFormState;
  agreedToTerms: boolean;
  setListing: React.Dispatch<React.SetStateAction<ListingFormState>>;
  setAgreedToTerms?: React.Dispatch<React.SetStateAction<boolean>>;
  initialListing: ListingFormState;
  editing?: boolean;
  thumbnail?: string;
};

const VisibilityForm: React.FC<VisibilityFormProps> = ({
  listing,
  initialListing,
  agreedToTerms,
  setListing,
  setAgreedToTerms,
  editing,
  thumbnail,
}) => (
  <StyledForm>
    <Visibility
      editing={editing}
      thumbnail={thumbnail}
      line1={listing.line1}
      line2={listing.line2}
      city={listing.city}
      province={listing.province}
      postal_code={listing.postal_code}
      list_price={listing.list_price}
      initialListing={initialListing}
      visibility={listing.visibility}
      pendingVisibility={listing.pendingVisibility}
      pageStatus={listing.pageStatus}
      status={listing.status}
      agreedToTerms={agreedToTerms}
      setListing={setListing}
      setAgreedToTerms={setAgreedToTerms}
    />
  </StyledForm>
);

export default VisibilityForm;
